import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, FormControl, IconButton, InputAdornment, OutlinedInput, TextField } from '@mui/material';
import { useCallback } from 'react';
import moment from "moment";
import AgGridTable from 'src/app/main/utilities/AgGridTable';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import { useParams } from 'react-router-dom';
import uploadSingleFilePopup from '../upload-component/uploadSingleFilePopup';
import CustomDatePicker from 'src/app/main/utilities/CustomDatePicker';


/* -------------------------------- Date -------------------------------- */
const DateEditor = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [error, setError] = useState("")
    const [Date, setDate] = useState(null);

    const handleDateChange = (newValue) => {
        setDate(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {
        if (props.data.date) {
            setDate(props.data.date);
        }
    }, [props.data]);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (Date !== null) {
                    return moment(Date).format('YYYY-MM-DD');

                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'Date'}
            value={Date ? Date : (!props.value ? null : props.value)}
            handleChange={handleDateChange}
            ref={refDatePicker}
        />
    );
});

const trainingEducationData = [
    { trainingType: "Intern", serviceProvider: "", location: "", duration: "", date: "", cost: "", remarks: "", attachFile: "", },
]


const ContinuousEductionDetail = ({ personalInfo, setSnackState, setSuccessMsg }) => {
    const gridRef = useRef();
    const params = useParams();
    const [gridApi, setGridApi] = useState(null);
    const [trainingEducation, setTrainingEducation] = useState(trainingEducationData)
    const [uploadDocument, setUploadDocument] = useState([]);

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const [trainingEductionColumnDefs, setTrainingEductionColumnDefs] = useState([
        { field: 'file', enableRowGroup: false, hide: true, editable: false },
        { field: 'trainingType', enableRowGroup: true },
        { field: 'serviceProvider', enableRowGroup: true },
        { field: 'location', enableRowGroup: true },
        { field: 'duration', enableRowGroup: true },
        { field: 'date', enableRowGroup: true, cellEditor: DateEditor, cellRenderer : handleDateFormat },
        { field: 'cost', enableRowGroup: true },
        { field: 'remarks', enableRowGroup: true },
        {
            field: 'uploadFile', enableRowGroup: true, cellEditor: uploadSingleFilePopup, cellStyle: {
                textAlign: 'right',
            }
        },
    ]);

    const onGridReady = useCallback((params) => {
        setGridApi(params);
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, [trainingEducation]);

    /*------------------------------Inline Row editing options-------------------------------*/

    const onBtAdd = useCallback((event) => {
        const newRow = {}
        const newRowDate = gridRef.current.api.applyTransaction({ add: [newRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        // let index = trainingEducation.findIndex((row) => row.id === event.node.data.id);
        // const nextIndex = index + 1;
        // trainingEducation.splice(RowIndex, 0, newRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'trainingType')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'trainingType',
            });
        }, 800);
    }, []);
    const onBtStartEditing = useCallback((event) => {
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'trainingType')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'trainingType',
        });
    }, []);
    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        trainingEducation.splice(event.node.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
    }, [gridApi, trainingEducation])

    const getContextMenuItems = (event) => {
        const data = event?.node?.data;
        var result = [
            {
                name: "Add Row",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            {
                name: "Delete Row",
                disabled: !data,
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
        ];
        return result;
    };

    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;
        const model = {
            id: data.docId ? data.docId : "",
            trainingType: data.trainingType,
            serviceProvider: data.serviceProvider,
            location: data.location,
            duration: data.duration,
            date: data.date,
            empId: params.id ? params.id : personalInfo.employeeId,
            cost: data.cost,
            rowIndex: event.node.rowIndex,
            remarks: data.remarks
        }
        if (params.id) {
            if (data.docId) {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.id === event.node.data.id) {
                            item.trainingType = data.trainingType,
                                item.serviceProvider = data.serviceProvider,
                                item.location = data.location,
                                item.duration = data.duration,
                                item.date = data.date,
                                item.empId = params.id ? params.id : personalInfo.employeeId,
                                item.cost = data.cost,
                                item.remarks = data.remarks
                        }
                        return item;
                    });
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            } else {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.rowIndex === event.node.rowIndex) {
                            item.trainingType = data.trainingType,
                                item.serviceProvider = data.serviceProvider,
                                item.location = data.location,
                                item.duration = data.duration,
                                item.date = data.date,
                                item.empId = params.id ? params.id : personalInfo.employeeId,
                                item.cost = data.cost,
                                item.remarks = data.remarks
                        }
                        return item;
                    })
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            }

        } else {
            if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                const updatedData = uploadDocument.map((item) => {
                    if (item.rowIndex === event.node.rowIndex) {
                        item.trainingType = data.trainingType,
                            item.serviceProvider = data.serviceProvider,
                            item.location = data.location,
                            item.duration = data.duration,
                            item.date = data.date,
                            item.empId = params.id ? params.id : personalInfo.employeeId,
                            item.cost = data.cost,
                            item.remarks = data.remarks
                    }
                    return item;
                })
                setUploadDocument(updatedData);
            } else {
                setUploadDocument([...uploadDocument, model]);
            }
        }

    }, [uploadDocument, personalInfo]);
    return (
        <div>
            <div className='flex justify-end mb-16'>
                <Button
                    // onClick={handleSubmit}
                    variant="contained"
                    color="warning"
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                    Save Document
                </Button>
            </div>
            <div style={{ height: "500px" }}>
                <AgGridTable
                    columnDefs={trainingEductionColumnDefs}
                    rowData={trainingEducation}
                    onRowValueChanged={onRowValueChanged}
                    onGridReady={onGridReady}
                    gridRef={gridRef}
                    editable={true}
                    editType={'fullRow'}
                    paginationPageSize={10}
                    getContextMenuItems={getContextMenuItems}
                    saveGridStateName={'trainingEduction'}
                />
            </div>
        </div>
    )
}

export default ContinuousEductionDetail